export var I18nLabel;
(function (I18nLabel) {
    I18nLabel["Close_Tab"] = "Close";
    I18nLabel["Close_Tabset"] = "Close tab set";
    I18nLabel["Active_Tabset"] = "Active tab set";
    I18nLabel["Move_Tabset"] = "Move tab set";
    I18nLabel["Move_Tabs"] = "Move tabs(?)";
    I18nLabel["Maximize"] = "Maximize tab set";
    I18nLabel["Restore"] = "Restore tab set";
    I18nLabel["Popout_Tab"] = "Popout selected tab";
    I18nLabel["Overflow_Menu_Tooltip"] = "Hidden tabs";
    I18nLabel["Error_rendering_component"] = "Error rendering component";
})(I18nLabel || (I18nLabel = {}));
//# sourceMappingURL=I18nLabel.js.map